var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VouchCategory',{attrs:{"title":"Für die ganze Familie","isMinimal":true,"ids":_vm.vouchers,"showButton":false,"hideTitle":true,"isPlugin":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }